import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import { ChallengeCriteria, ChallengeCriteriaType } from './ChallengeCriteria';
import { CHALLENGE_CRITERIAS } from './ChallengeCriterias.constants';
import './ChallengeCriterias.scss';

const b = cn('challenge-criterias');

const renderCriteria = (item: ChallengeCriteriaType) => <ChallengeCriteria {...item} />;
const extractTagKey = (_: ChallengeCriteriaType, index: number) => `criteria-${index}`;

export const ChallengeCriterias = () => {
    return (
        <Stack className={b()}>
            <h2 className={b('title')}>Критерии оценки</h2>
            <List
                direction="row"
                className={b('list')}
                items={CHALLENGE_CRITERIAS}
                renderItem={renderCriteria}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
